/* ============================================================
   KAF Set Builder — kaf-set-builder.js · 2026-07-03
   Renders configurable sets, resolves variants, adds the whole
   set to the cart in one move and locks in the set discount.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('kaf-sb');
  var mount = root && root.querySelector('[data-kaf-sb-cards]');
  if (!mount) return;

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var PRODUCTS = readJSON('kaf-sb-products') || {};
  var SETS = readJSON('kaf-sb-sets') || [];

  var SWATCH = {
    'black': { bg: '#202024', br: '#141417' },
    'beige': { bg: '#E2DED4', br: '#C4BFB5' },
    'white': { bg: '#F5F4EF', br: '#C0BDB8' },
    'olive': { bg: '#6B7055', br: '#5A5E46' }
  };

  function money(cents) {
    var v = Math.round(cents) / 100;
    return (v % 1 === 0 ? String(v) : v.toFixed(2)) + ' JD';
  }

  function optIndex(product, name) {
    for (var i = 0; i < product.options.length; i++) {
      if (String(product.options[i]).toLowerCase() === name) return i;
    }
    return -1;
  }
  function optValues(product, name) {
    var idx = optIndex(product, name);
    if (idx < 0) return [];
    var seen = [], out = [];
    product.variants.forEach(function (v) {
      var val = v.options[idx];
      if (seen.indexOf(val) === -1) { seen.push(val); out.push(val); }
    });
    return out;
  }
  function findVariant(product, color, size) {
    var ci = optIndex(product, 'color'), si = optIndex(product, 'size');
    return product.variants.filter(function (v) {
      return (ci < 0 || v.options[ci] === color) && (si < 0 || v.options[si] === size);
    })[0] || null;
  }
  function sizeAvailable(product, color, size) {
    var v = findVariant(product, color, size);
    return !!(v && v.available);
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html !== undefined) e.innerHTML = html;
    return e;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── Build one card ───────────────────────────────────────── */
  SETS.forEach(function (set) {
    var validPieces = set.pieces.filter(function (piece) {
      return piece.fits.some(function (f) { return PRODUCTS[f.handle]; });
    });
    if (validPieces.length !== set.pieces.length) return; /* product missing → skip set */

    var card = el('article', 'kaf-sb__card' + (set.hero ? ' kaf-sb__card--hero' : ''));
    card.setAttribute('aria-label', set.name);

    var state = set.pieces.map(function (piece, i) {
      var firstFit = piece.fits[0].handle;
      var product = PRODUCTS[firstFit];
      return {
        fit: firstFit,
        color: optValues(product, 'color')[0] || null,
        size: null,
        open: i === 0
      };
    });

    function fitName(piece, handle) {
      var f = piece.fits.filter(function (x) { return x.handle === handle; })[0];
      return f ? f.name : '';
    }
    function openOnly(pi) {
      state.forEach(function (st, i) { st.open = i === pi; });
      state.forEach(function (_, i) { rerenderPiece(i); });
    }
    function advanceFrom(pi) {
      var next = -1;
      for (var i = 1; i <= state.length; i++) {
        var idx = (pi + i) % state.length;
        if (!state[idx].size) { next = idx; break; }
      }
      if (next === -1) { state.forEach(function (st) { st.open = false; }); }
      else { state.forEach(function (st, i) { st.open = i === next; }); }
      state.forEach(function (_, i) { rerenderPiece(i); });
    }

    /* head */
    var head = el('div', 'kaf-sb__card-head');
    var headL = el('div', '');
    headL.appendChild(el('p', 'kaf-sb__card-eyebrow',
      '<span class="kaf-sb__card-morse" aria-hidden="true">' + esc(set.morse) + '</span>' + esc(set.eyebrow)));
    headL.appendChild(el('h2', 'kaf-sb__card-name', esc(set.name)));
    headL.appendChild(el('p', 'kaf-sb__card-tag', esc(set.tagline)));
    head.appendChild(headL);
    head.appendChild(el('span', 'kaf-sb__save', 'SAVE ' + money(set.save)));
    card.appendChild(head);

    /* pieces */
    var piecesWrap = el('div', 'kaf-sb__pieces');
    card.appendChild(piecesWrap);

    /* foot */
    var foot = el('div', 'kaf-sb__foot');
    var pricing = el('div', 'kaf-sb__pricing');
    var wasEl = el('span', 'kaf-sb__price-was');
    var nowEl = el('span', 'kaf-sb__price-now');
    var saveEl = el('span', 'kaf-sb__price-save');
    pricing.appendChild(nowEl); pricing.appendChild(wasEl); pricing.appendChild(saveEl);
    var addBtn = el('button', 'kaf-sb__add');
    addBtn.type = 'button';
    var hint = el('p', 'kaf-sb__hint');
    foot.appendChild(pricing); foot.appendChild(addBtn); foot.appendChild(hint);
    card.appendChild(foot);

    function renderPiece(pi) {
      var piece = set.pieces[pi];
      var st = state[pi];
      var product = PRODUCTS[st.fit];
      var box = el('div', 'kaf-sb__piece' + (st.open ? ' is-open' : '') + (st.size ? ' is-done' : ''));
      box.dataset.piece = pi;

      /* header: image + label + selection summary + chevron (click to open) */
      var top = el('button', 'kaf-sb__piece-top');
      top.type = 'button';
      top.setAttribute('aria-expanded', st.open ? 'true' : 'false');
      var img = el('img', 'kaf-sb__piece-img');
      img.src = product.image || '';
      img.alt = '';
      img.loading = 'eager';
      img.decoding = 'async';
      img.width = 44; img.height = 58;
      top.appendChild(img);
      var meta = el('div', 'kaf-sb__piece-meta');
      meta.appendChild(el('div', 'kaf-sb__piece-label', esc(piece.label)));
      var summary = st.size
        ? esc(fitName(piece, st.fit)) + ' · ' + esc(st.color || '') + ' · ' + esc(st.size)
        : esc(product.title) + ' · ' + money(product.price);
      meta.appendChild(el('div', 'kaf-sb__piece-price', summary));
      top.appendChild(meta);
      top.appendChild(el('span', 'kaf-sb__piece-state' + (st.size ? ' is-done' : ''),
        st.size
          ? '<svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 7L5.5 10.5L12 3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          : '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'));
      top.addEventListener('click', function () {
        if (st.open) { st.open = false; rerenderPiece(pi); }
        else { openOnly(pi); }
      });
      box.appendChild(top);

      var body = el('div', 'kaf-sb__piece-body');
      if (!st.open) body.hidden = true;
      box.appendChild(body);

      /* fit toggle */
      if (piece.fits.length > 1) {
        var fits = el('div', 'kaf-sb__fits');
        fits.setAttribute('role', 'group');
        fits.setAttribute('aria-label', piece.label + ' fit');
        piece.fits.forEach(function (f) {
          if (!PRODUCTS[f.handle]) return;
          var b = el('button', 'kaf-sb__fit' + (f.handle === st.fit ? ' is-active' : ''), esc(f.name));
          b.type = 'button';
          b.setAttribute('aria-pressed', f.handle === st.fit ? 'true' : 'false');
          b.addEventListener('click', function () {
            if (st.fit === f.handle) return;
            st.fit = f.handle;
            var np = PRODUCTS[st.fit];
            if (optValues(np, 'color').indexOf(st.color) === -1) st.color = optValues(np, 'color')[0] || null;
            if (st.size && !sizeAvailable(np, st.color, st.size)) st.size = null;
            rerenderPiece(pi);
            update();
          });
          fits.appendChild(b);
        });
        body.appendChild(fits);
      }

      /* colour swatches */
      var colors = optValues(product, 'color');
      if (colors.length) {
        var sw = el('div', 'kaf-sb__swatches');
        sw.setAttribute('role', 'radiogroup');
        sw.setAttribute('aria-label', piece.label + ' colour');
        colors.forEach(function (c) {
          var conf = SWATCH[c.toLowerCase()] || { bg: '#909090', br: '#707070' };
          var b = el('button', 'kaf-sb__swatch' + (c === st.color ? ' is-active' : ''));
          b.type = 'button';
          b.style.setProperty('--sw-bg', conf.bg);
          b.style.setProperty('--sw-br', conf.br);
          b.setAttribute('aria-label', piece.label + ' colour: ' + c);
          b.setAttribute('aria-pressed', c === st.color ? 'true' : 'false');
          b.addEventListener('click', function () {
            st.color = c;
            if (st.size && !sizeAvailable(product, st.color, st.size)) st.size = null;
            rerenderPiece(pi);
            update();
          });
          sw.appendChild(b);
        });
        body.appendChild(sw);
      }

      /* sizes */
      var sizes = optValues(product, 'size');
      if (sizes.length) {
        var sz = el('div', 'kaf-sb__sizes');
        sz.setAttribute('role', 'radiogroup');
        sz.setAttribute('aria-label', piece.label + ' size');
        sizes.forEach(function (s) {
          var avail = sizeAvailable(product, st.color, s);
          var b = el('button', 'kaf-sb__size' + (s === st.size ? ' is-active' : '') + (avail ? '' : ' is-sold-out'), esc(s));
          b.type = 'button';
          b.disabled = !avail;
          b.setAttribute('aria-pressed', s === st.size ? 'true' : 'false');
          b.addEventListener('click', function () {
            st.size = s;
            update();
            advanceFrom(pi);
          });
          sz.appendChild(b);
        });
        body.appendChild(sz);
      }

      return box;
    }

    function rerenderPiece(pi) {
      var old = piecesWrap.querySelector('[data-piece="' + pi + '"]');
      var fresh = renderPiece(pi);
      if (old) piecesWrap.replaceChild(fresh, old);
    }

    function resolved() {
      return state.map(function (st) {
        var product = PRODUCTS[st.fit];
        if (!st.size && optValues(product, 'size').length) return null;
        var v = findVariant(product, st.color, st.size);
        return v && v.available ? v : null;
      });
    }

    function update() {
      var vs = resolved();
      var total = 0;
      state.forEach(function (st, i) {
        var product = PRODUCTS[st.fit];
        total += vs[i] ? vs[i].price : product.price;
      });
      var setPrice = total - set.save;
      nowEl.textContent = money(setPrice);
      wasEl.textContent = money(total);
      saveEl.textContent = '— SAVE ' + money(set.save);
      var missing = vs.reduce(function (n, v) { return n + (v ? 0 : 1); }, 0);
      var ready = missing === 0;
      addBtn.disabled = !ready;
      addBtn.innerHTML = ready
        ? 'ADD SET TO BAG <span aria-hidden="true">→</span>'
        : 'ADD SET TO BAG';
      hint.textContent = ready
        ? 'Saving applies automatically at checkout.'
        : 'Pick a size for ' + (missing === 1 ? 'one more piece' : missing + ' pieces') + '.';
    }

    addBtn.addEventListener('click', function () {
      var vs = resolved();
      if (vs.some(function (v) { return !v; })) return;

      /* merge duplicate variants (Duo with same tee twice) */
      var qty = {};
      vs.forEach(function (v) { qty[v.id] = (qty[v.id] || 0) + 1; });
      var items = Object.keys(qty).map(function (id) {
        return { id: parseInt(id, 10), quantity: qty[id], properties: { '_Set': set.name } };
      });

      var sectionIds = Array.prototype.slice.call(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map(function (e) { return e.dataset.sectionId; }).filter(Boolean);

      addBtn.classList.add('is-loading');
      addBtn.textContent = 'ADDING…';

      /* 1. register the hidden set discount code (cookie) */
      fetch('/discount/' + encodeURIComponent(set.code), { method: 'GET', credentials: 'same-origin' })
        .catch(function () { /* non-critical */ })
        .then(function () {
          /* 2. add all pieces in one call */
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: items,
              sections: sectionIds.join(','),
              sections_url: window.location.pathname
            })
          });
        })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (r) {
          if (!r.ok || (r.data && (r.data.status || r.data.errors))) {
            addBtn.classList.remove('is-loading');
            addBtn.textContent = 'COULD NOT ADD — TRY AGAIN';
            setTimeout(update, 2600);
            return;
          }
          return fetch('/cart.js').then(function (res) { return res.json(); }).catch(function () { return null; })
            .then(function (cart) {
              var evt = new Event('cart:update', { bubbles: true });
              evt.detail = {
                resource: cart || undefined,
                sourceId: 'kaf-set-builder',
                data: { source: 'product-form-component', itemCount: items.reduce(function (n, i) { return n + i.quantity; }, 0), sections: r.data && r.data.sections }
              };
              document.dispatchEvent(evt);
              addBtn.classList.remove('is-loading');
              addBtn.classList.add('is-added');
              addBtn.innerHTML = 'SET ADDED <svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 7L5.5 10.5L12 3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
              hint.textContent = 'Saving locked in — applied at checkout.';
              var drawer = document.querySelector('cart-drawer-component');
              try {
                if (drawer && typeof drawer.showDialog === 'function') { drawer.showDialog(); }
                else if (drawer && typeof drawer.open === 'function') { drawer.open(); }
              } catch (e) { /* noop */ }
              setTimeout(function () {
                addBtn.classList.remove('is-added');
                update();
              }, 3200);
            });
        })
        .catch(function () {
          addBtn.classList.remove('is-loading');
          addBtn.textContent = 'COULD NOT ADD — TRY AGAIN';
          setTimeout(update, 2600);
        });
    });

    set.pieces.forEach(function (_, pi) { piecesWrap.appendChild(renderPiece(pi)); });
    update();
    mount.appendChild(card);
  });
})();
